import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// A random ID for this browser (no personal data). Used to spot one person running many accounts.
function deviceId() {
    try {
        let id = localStorage.getItem("g2c_device");
        if (!id) {
            id = (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID()
                : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
            localStorage.setItem("g2c_device", id);
        }
        return id;
    } catch { return ""; }
}

// Attach token from localStorage as Bearer header
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    const dev = deviceId();
    if (dev) config.headers["X-Device-Id"] = dev;
    return config;
});

// If 401, only redirect to login if on a protected page
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem("access_token");
            const path = window.location.pathname;
            const isProtected = path.startsWith("/dashboard") || path.startsWith("/admin");
            if (isProtected && !path.includes("/login")) {
                window.location.href = "/login";
            }
        }
        return Promise.reject(error);
    }
);

export default api;